module.exports = __webpack_public_path__ + "static/media/003_productType@2x.70ceb2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/003_productType@2x.png
// module id = 565
// module chunks = 0